// extracted by mini-css-extract-plugin
export default {"main":"main_main__CstcB","inner":"main_inner__HTi7I"};